module.exports = __webpack_public_path__ + "static/media/Group 776.138e6762.svg";